import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { AdminAuthService } from '../../services/admin-auth.service';

@Component({
  selector: 'app-admin-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-change-password.component.html',
  styleUrls: ['./admin-change-password.component.scss']
})
export class AdminChangePasswordComponent {
  currentPassword = '';
  newPassword = '';
  confirmPassword = '';
  loading = false;
  error = '';

  constructor(
    private apiService: ApiService,
    private adminAuthService: AdminAuthService,
    private router: Router
  ) {}

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  get hasMinLength(): boolean {
    return this.newPassword.length >= 8;
  }

  onSubmit(): void {
    if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
      this.error = 'Please fill in all fields';
      return;
    }

    if (!this.hasMinLength) {
      this.error = 'New password must be at least 8 characters long';
      return;
    }

    if (!this.passwordsMatch) {
      this.error = 'New passwords do not match';
      return;
    }

    if (!this.adminAuthService.isAuthenticated()) {
      this.router.navigate(['/admin/login']);
      return;
    }

    this.loading = true;
    this.error = '';

    this.apiService.adminChangePassword(
      { currentPassword: this.currentPassword, newPassword: this.newPassword }
    ).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigate(['/admin']);
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || 'Failed to change password. Please try again.';
      }
    });
  }
}
